/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { locationResponseSchema } from './locationResponseSchema';

export const pageResponseLocationResponseSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(locationResponseSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
